import React, { useState } from 'react';
import styled from 'styled-components';

const HelpButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  font-size: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  cursor: pointer;
  z-index: 1000;
`;

const Modal = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 0.75rem;
  padding: 2rem;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #2563eb;
  font-size: 1.1rem;
  float: right;
  cursor: pointer;
`;

const HelpWidget: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <HelpButton title="Help" onClick={() => setOpen(true)}>?</HelpButton>
      {open && (
        <Modal>
          <ModalContent>
            <CloseBtn onClick={() => setOpen(false)}>Close</CloseBtn>
            <h3 style={{marginTop:0}}>Need Help?</h3>
            <ul style={{fontSize:'0.95em', color:'#374151', marginBottom:16}}>
              <li>• How do I create a class? Use the "Create Class" button on your dashboard.</li>
              <li>• How do I schedule a lesson? Use the "Quick Actions" section.</li>
              <li>• For more help, contact support below.</li>
            </ul>
            <a href="mailto:support@school.com" style={{color:'#2563eb'}}>Contact Support</a>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default HelpWidget; 